import { Moment } from 'moment';

export class AuthResponse {
  expires: number;
  access_token: string;
}
